import { render, staticRenderFns } from "./Specification.html?vue&type=template&id=b28bba1a&scoped=true&external"
import script from "./Specification.js?vue&type=script&lang=js&external"
export * from "./Specification.js?vue&type=script&lang=js&external"
import style0 from "./Specification.scss?vue&type=style&index=0&id=b28bba1a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28bba1a",
  null
  
)

export default component.exports